var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuperfast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61,
    height: 59,
    viewBox: "0 0 61 59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3616",
    "data-name": "Group 3616",
    transform: "translate(0.473)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 30.5,
    cy: 29.5,
    rx: 30.5,
    ry: 29.5,
    transform: "translate(-0.473)",
    fill: "#e2f4f0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "time-fast_1_",
    "data-name": "time-fast (1)",
    transform: "translate(18.527 18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_473",
    "data-name": "Path 473",
    d: "M10,23a1,1,0,0,1-1,1H1a1,1,0,0,1,0-2H9A1,1,0,0,1,10,23Z",
    fill: "#00d1a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_474",
    "data-name": "Path 474",
    d: "M1,20H7a1,1,0,0,0,0-2H1a1,1,0,0,0,0,2Z",
    fill: "#00d1a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_475",
    "data-name": "Path 475",
    d: "M1,16H5a1,1,0,0,0,0-2H1a1,1,0,0,0,0,2Z",
    fill: "#00d1a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_476",
    "data-name": "Path 476",
    d: "M12,0A12,12,0,0,0,0,12c0,.061.008.12.009.181A2.966,2.966,0,0,1,1,12H5a2.99,2.99,0,0,1,2.78,4.116,2.975,2.975,0,0,1,2,4,2.949,2.949,0,0,1,2.039,3.875c.061,0,.12.009.181.009A12,12,0,1,0,12,0Zm3.707,15.707a1,1,0,0,1-1.414,0l-3-3A1,1,0,0,1,11,12V7a1,1,0,0,1,2,0v4.586l2.707,2.707a1,1,0,0,1,0,1.414Z",
    fill: "#00d1a9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuperfast);
export default __webpack_public_path__ + "static/media/superfast.ded5a1e546788ea7ae5726470e66e83e.svg";
export { ForwardRef as ReactComponent };